import { useAppSelector } from "../hook";
/**
 * Read-only view of a cached rulebook — never dispatches a fetch. With a `conversationId` whose resolved Rulebook is
 * hydrated (pinned, or its persona's), that one wins, so message chips label meters with the definition the turn used.
 */
export default function useCharacterRulebookView(characterId, conversationId, personaId) {
    return useAppSelector((state) => {
        if (conversationId && conversationId in state.rulebook.byConversationId) {
            return state.rulebook.byConversationId[conversationId] ?? null;
        }
        if (personaId && state.rulebook.byPersonaId[personaId]) {
            return state.rulebook.byPersonaId[personaId] ?? null;
        }
        return characterId ? (state.rulebook.byCharacterId[characterId] ?? null) : null;
    });
}
